import FAQSection from '@/pages/home/sections/FaqSection'
import { TopSection } from '@/pages/home/sections/TopSection'
import SocialNetworkSection from '@/pages/home/sections/SocialNetworkSection'
import { CertificationRibbon } from '@/components/CertificationRibbon'
import WhatIsPepperSection from '@/pages/home/sections/WhatIsPepperSection'
import { PepperStatsSection } from '@/pages/home/sections/PepperStatsSection'
import PepperIncSection from '@/pages/home/sections/PepperIncSection'
import { PollMapSection } from './sections/poll-map/PollMapSection'

const Home = () => {
	return (
		<div className="mx-auto overflow-x-hidden">
			<TopSection />
			<PepperStatsSection />
			<PepperIncSection />
			<PollMapSection />
			<WhatIsPepperSection />
			<FAQSection />
			<SocialNetworkSection />
			<CertificationRibbon />
		</div>
	)
}

export default Home
